import { useState } from 'react';

import {
  Typography,
  Button,
  Modal,
  Checkbox,
  Icon,
} from '@safedns/skydns-ui-react-lib';

import CircularProgress from '../UI/circular-progress';

import sprite from '../../icons/sprite.svg';

import styles from './AuthKeyRegenerateDialog.module.scss';

const DeleteAuthKeyDialog = ({
  isDialogShow,
  onDialogAction,
  onCreateAction,
  isAuthKeyRegenerating,
}) => {
  const [isChecked, setCheckboxState] = useState(false);

  const checkboxStateHandler = () => {
    setCheckboxState((prevState) => !prevState);
  };

  return (
    <Modal
      isOpen={isDialogShow}
      title="Перевыпустить ключ"
      onClose={onDialogAction}
      sx={{ maxWidth: 520 }}
    >
      <div className={styles['dialog-content']}>
        <div className={styles['warning-box']}>
          <Icon id="info" sprite={sprite} className={styles['warning-icon']} />
          <Typography
            variant="body1"
            component="span"
            className={styles['warning-text']}
          >
            После перевыпуска старый ключ перестанет работать
          </Typography>
        </div>
        <Checkbox
          isChecked={isChecked}
          onChange={checkboxStateHandler}
          className={styles['checkbox-wrapper']}
          label="Я понимаю, что старый ключ перестанет работать и его нельзя будет восстановить"
        />
        <div className={styles['button-grid']}>
          <Button
            variant="secondary"
            size="small"
            onClick={onDialogAction}
            className={styles['button-cancel']}
          >
            Отменить
          </Button>
          <Button
            variant="primary"
            size="small"
            onClick={onCreateAction}
            isDisabled={!isChecked || isAuthKeyRegenerating}
            className={styles['button-regenerate']}
          >
            Перевыпустить
            {isAuthKeyRegenerating ? (
              <CircularProgress size={15} className={styles['loader']} />
            ) : null}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteAuthKeyDialog;
